import { createSelector } from 'reselect';

import { selectSensorsCurrent, selectSensorMeta } from '../../store/selectors';

const selectHumiditySensors = createSelector(
  selectSensorsCurrent,
  sensors => sensors.filter(
    ({ data }) => data[0] && !!data[0].hum_last, // TODO: Include hum_out
  ),
);

export const selectHumidityReadings = createSelector(
  selectHumiditySensors,
  selectSensorMeta,
  (sensors, meta) => sensors.map(sensor => {
    const sensorMeta = meta.find(s => s.lsid === sensor.lsid);
    return {
      lsid: sensor.lsid,
      x: sensorMeta.x,
      y: sensorMeta.y,
      hum: sensor.data[0].hum_last,
    }
  })
)



// WEBPACK FOOTER //
// ./src/plots/Humidity/selectors.js